export const ShoppingCartService = (() => {
    const controllerRoot = '/api/shopping-cart';

    const getApiRoute = (path) => `${controllerRoot}/${path || ''}`;

    return {
        get: async (path) => {
            // @ts-ignore
            return await fetchClient().get(getApiRoute(path));
        },
        create: async (path, request) => {
            // @ts-ignore
            return await fetchClient().post(getApiRoute(path), request);
        },
        update: async (path, request) => {
            // @ts-ignore
            return await fetchClient().put(getApiRoute(path), request);
        },
        delete: async (path) => {
            // @ts-ignore
            return await fetchClient().delete(getApiRoute(path));
        },
        patch: async (path, request) => {
            // @ts-ignore
            return await fetchClient().patch(getApiRoute(path, request));
        }
    }
})();

export default ShoppingCartService;